import React, {useState} from "react";
import {withTranslation} from "react-i18next";
import {
    ArrowRightOutlined, InfoCircleOutlined, LeftOutlined
} from '@ant-design/icons';
import "../tek.scss";
import {Button, Tooltip} from 'antd';
import {history} from '_helpers/history'

import Headerbutton from "../../../component/headerButton";
import localOrSessionStore from "_helpers/localOrSessionStore";
import variables from "_constants/variables";
import luxs from "../../../../../assets/img/LUX_EMPODERADA.png";
import chronos from "../../../../../assets/img/chronos/chronos-normal.png";
import {useLocation} from "react-router-dom";

function TekInstructions(props) {
    const location = useLocation();
    const [restartQuestions, setRestartQuestions] =  useState(new URLSearchParams(location.search).get('restart') === 'true');

    const storage = localOrSessionStore({ key: variables.REMEMBER });
    const user = JSON.parse(storage.getItem(variables.USER));
    const {t} =props;

    const saveAndContinue = () => {
        history.push("/admin/dashboard")
    }

    const copyTek = () => <p className={"tooltip-text"} dangerouslySetInnerHTML={{__html: t('tek.copytek')}}></p>

    return (
        <>
            <div className={"containerStartTekTwo wrapper containerStartTekTwo--background"}>
                <div className={"insideTek boxed"}>
                    <Headerbutton  saveAndContinue={saveAndContinue}  />
                </div>
                <div className={"container-pre-question boxed"}>
                    <div className={"content-pre-question"}>
                        <div className={"content-text-scroll"}>
                            <p className={"pre-question-title"}>
                                {user.name ?? "" },&nbsp;{t("tek.itin1.init1")}&nbsp;
                                <br/>
                                {t("tek.itin1.init2")}&nbsp;
                                <Tooltip
                                    overlayStyle={{maxWidth: 500}}
                                    title={copyTek}
                                >
                                    <InfoCircleOutlined />
                                </Tooltip>
                            </p>
                            <p className={"pre-question-subtitle"}>{t("tek.itin1.init3")}</p>
                            <p className={"pre-question-list"} dangerouslySetInnerHTML={{__html: t('tek.itin1.init4')}} />
                            <p className={"pre-question-list"} dangerouslySetInnerHTML={{__html: t('tek.itin1.init5')}} />
                            <p className={"pre-question-list"} dangerouslySetInnerHTML={{__html: t('tek.itin1.init7')}} />
                            <p className={"pre-question-list"} dangerouslySetInnerHTML={{__html: t('tek.itin1.init8')}} />
                        </div>
                        <Button type={"primary"}
                                onClick={() => history.push(
                                    restartQuestions ? "/admin/start-tek?restart=true" : "/admin/start-tek")}
                                className="primaryButton btn-start">{t("tek.startq")}</Button>
                    </div>
                    <Button type="link"
                            icon={<LeftOutlined />}
                            onClick={() => history.push("/admin/tek")}
                            className={"btn-back"}

                    >
                        {t("atras")}
                    </Button>
                </div>
                <div className={"footerTek"}>
                    <p dangerouslySetInnerHTML={{__html: t('tek.copytek')}} />
                </div>

            </div>
        </>

    )
}

export default withTranslation()(TekInstructions);
